import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { Button } from 'shared/ui'
import { Table } from 'shared/ui/TableNew'
import { type RowCallHistory } from 'entities/CallHistory/model/Table/RowCallHistory'
import type { CallHistory } from 'entities/CallHistory/model/CallHistory'
import { columns } from 'pages/conversations/pages/calls/ui/CallHistoryTable/ui/getColumns'
import { type CallHistoryTableStore } from 'pages/conversations/pages/calls/ui/CallHistoryTable'
import styles from './styles.module.scss'

type ICallHistoryTableProps = {
  store: CallHistoryTableStore
  onOpenConversation: (item: CallHistory) => void
  noPagination?: boolean
}

export const CallHistoryTable: FC<ICallHistoryTableProps> = observer(
  ({ store, onOpenConversation }) => {
    const { markAsRead, tableStore, itemsRows, openExportModal, loading } = store

    const onRowClick = (row: RowCallHistory) => {
      if (row.isUnread) {
        markAsRead(row.origin)
      }
      onOpenConversation(row.origin)
    }

    return (
      <div className={styles.tableWrap}>
        <Table
          store={tableStore}
          ariaLabel={'CallHistoryTable'}
          columns={columns}
          pinnedColumnIds={['contact']}
          rows={itemsRows}
          loading={loading}
          hideExpandColumnsIds={['type']}
          sxTable={{ marginRight: 2, width: 'calc(100% - 16px)' }}
          onRowClick={onRowClick}
          rightHeaderContent={
            <Button
              icon='download'
              text='Export'
              typeBtn='contained'
              contained='tertiary'
              size='small'
              onClick={openExportModal}
            />
          }
          virtualization
        />
      </div>
    )
  }
)
